import { ChangeDetectionStrategy, Component } from '@angular/core';
import { viewLoader } from '../../../../../../assets/animations/animations';
import { PlatformJobsApplicationsComponent } from '../../components/jobs-applications/platform-jobs-applications.component';

@Component({
  selector: 'app-platform-applications-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlatformJobsApplicationsComponent],
  template: `
    <div class="view-wrapper table-view-wrapper" @viewLoader>
      <div class="view-content xl table-view">
        <div class="view-section">
          <app-platform-jobs-applications />
        </div>
      </div>
    </div>
  `,
  styleUrl: './platform-applications-view.component.scss',
  animations: [viewLoader],
})
export class PlatformApplicationsViewComponent {}
